import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters/getters.js'

import user from './modules/user'
import Modules from './modules'
Vue.use(Vuex)

const store = new Vuex.Store({
  getters,
  modules: {
    ...Modules,
    user
  }
})

// 实现vuex的热更替
if (module.hot) {
  // module.hot.accept 表示需要热更替的是哪些文件
  module.hot.accept(
    [
      './getters/getters',
      './modules/user'
    ],
    () => {
      // 获取更新后的模块
      // 因为 babel 6 的模块编译格式问题，这里需要加上 `.default`
      const newGetters = require('./getters/getters').default
      const user = require('./modules/user').default
      // 加载新模块
      store.hotUpdate({
        getters: newGetters,
        modules: {
          user
        }
      })
    }
  )
}
export default store
